
import { defineComponent, onBeforeMount, ref } from 'vue';

export default defineComponent({
  name: 'SearchBar',
  // eslint-disable-next-line vue/require-default-prop
  props: { data: [Array], placeholder: { type: String, default: 'Search' } },
  setup(props) {
    const search = ref('');
    const placeHolder1 = ref();
    const filteredProgramDetails = ref();
    const ProgramDetails = ref();
    const filterProgramDetails = () => {
      // console.log('props.data', props.data);
      ProgramDetails.value = props.data;
      filteredProgramDetails.value = ProgramDetails.value.filter((program) => program.toLowerCase().includes(search.value.toLowerCase()));
      // console.log('filteredProgramDetails', filteredProgramDetails);
    };
    onBeforeMount(async () => {
      // console.log('props.data onbefore mount', props.data);
      placeHolder1.value = props.placeholder;
      console.log('props.placeholder', props.placeholder);
    });
    return { placeHolder1, filteredProgramDetails, filterProgramDetails, search };
  },
});
